import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { toggleSidebar } from 'redux/actions';

const PageBackbutton = ({ url, children }) => {
    const dispatch = useDispatch();
    const buttonProps = {
        as: url && url !== '#' && Link,
        variant: url && url === '#' ? 'button' : 'link',
        to: url !== '#' ? url : null,
        className: "page__title--button",
        onClick: () => {
            url === '#' && dispatch(toggleSidebar());
        }
    }
    return (
        <Fragment>
            <Button {...buttonProps}>
                <ArrowBackOutlinedIcon />
            </Button>
            {children}
        </Fragment>
    );
};

PageBackbutton.propTypes = {
    children: PropTypes.any.isRequired,
    url: PropTypes.string.isRequired,
};

export default PageBackbutton;
